import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import ContentArea from '../../components/contentArea';
import RadioButton from '../../components/radioButton';
import { settingAPI } from '../../actions/imsServer';
import { PUSH_OPTIONS, API_PAGE_SIZE } from '../../constants';

export const UserPush = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    const [settings, setSettings] = useState(() => {
        const initial = {};
        PUSH_OPTIONS.forEach((o) => {
            initial[o.key] = o.defaultValue;
        });
        return initial;
    });

    // DB setting 존재 여부(없으면 registerSetting 필요)
    const [remoteExists, setRemoteExists] = useState(() => {
        const init = {};
        PUSH_OPTIONS.forEach((o) => { init[o.key] = false; });
        return init;
    });

    useEffect(() => {
        const fetchSettings = async () => {
            const meInfo = JSON.parse(localStorage.getItem('meInfo') || '{}');
            if (!meInfo?.id) return;

            try {
                let list = [];
                let offset = 0;
                let page;
                do {
                    const res = await settingAPI.getSettings({
                        userId: meInfo.id,
                        offset
                    });
                    page = Array.isArray(res?.settings)
                        ? res.settings
                        : Array.isArray(res?.data?.settings)
                            ? res.data.settings
                            : [];
                    list = list.concat(page);
                    offset += API_PAGE_SIZE;
                } while (page.length === API_PAGE_SIZE);

                const findSetting = (name) => list.find((s) => s?.name === name);

                const applyRemote = (name, defaultValue) => {
                    const s = findSetting(name);
                    return {
                        exists: !!s,
                        value: s ? (s.value === true || s.value === 'true') : defaultValue,
                    };
                };

                const applied = {};
                const exists = {};
                PUSH_OPTIONS.forEach((o) => {
                    const r = applyRemote(o.key, o.defaultValue);
                    applied[o.key] = r.value;
                    exists[o.key] = r.exists;
                });

                setSettings((prev) => ({ ...prev, ...applied }));
                setRemoteExists(exists);
            } catch {
                // 에러 시 기본값 유지
            }
        };

        fetchSettings();
    }, []);

    // stepPush 변경 시 웹뷰 AsyncStorage에 저장
    useEffect(() => {
        if (typeof window !== 'undefined' && window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify({ type: 'stepPushSetting', value: Boolean(settings.stepPush) })
            );
        }
    }, [settings.stepPush]);

    const updateRemoteSetting = async (name, value) => {
        const meInfo = JSON.parse(localStorage.getItem('meInfo') || '{}');
        if (!meInfo?.id) return;

        try {
            if (remoteExists[name]) {
                await settingAPI.updateSetting({ name, value: value.toString() });
            } else {
                await settingAPI.registerSetting({ name, value: value.toString() });
                setRemoteExists((prev) => ({ ...prev, [name]: true }));
            }
        } catch (e) {
            // 실패 시에는 UI 롤백까지는 하지 않음(필요하면 추가 가능)
        }
    };

    return (
        <ContentArea sx={{ padding: '40px 0px 40px 0px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '60px', width: '100%' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
                    {PUSH_OPTIONS.map((o) => (
                        <Box
                            key={o.key}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                pl: '15px',
                                width: '100%',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    color: theme.palette.figma.white[60],
                                    letterSpacing: '-0.42px',
                                }}
                            >
                                {t(o.label)}
                            </Typography>
                            <RadioButton
                                checked={Boolean(settings[o.key])}
                                onChange={(checked) => {
                                    setSettings((prev) => ({ ...prev, [o.key]: checked }));
                                    updateRemoteSetting(o.key, checked);
                                }}
                            />
                        </Box>
                    ))}
                </Box>
            </Box>
        </ContentArea>
    );
};

export default UserPush;
